import { isNil } from 'lodash';
import type { State, Portal, PersistedError, Category } from './types';

export const NOT_SUPPORTED: { __NOT_SUPPORTED__: true } = { __NOT_SUPPORTED__: true };

export const getPortalOrError = (state: State, portalId?: number): Portal | PersistedError | undefined => {
    if (isNil(portalId)) {
        return undefined;
    }

    return state.persisted.portals[portalId];
};

export const getPortal = (state: State, portalId?: number): Portal | undefined => {
    const portal = getPortalOrError(state, portalId);
    if (!portal || 'error' in portal) {
        return undefined;
    }

    return portal;
};

export const getProjectId = (state: State, portalId: number | undefined): number | undefined => {
    if (isNil(portalId)) {
        return undefined;
    }
    const portal = getPortal(state, portalId);
    return portal ? portal.projectId : undefined;
};

export const getName = (state: State, portalId: number | undefined): string | undefined => {
    const portal = getPortal(state, portalId);
    return portal ? portal.name : undefined;
};

export const getPortalAnnouncement = (state: State, portalId: number | undefined) => {
    const portal = getPortal(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};

export const getCanAdministerProject = (state: State, portalId: number | undefined): boolean => {
    const portalAnnouncement = getPortalAnnouncement(state, portalId);
    return portalAnnouncement ? portalAnnouncement.canAdministerProject : false;
};

export const getIsProjectSimplified = (state: State, portalId: number | undefined): boolean => {
    const portal = getPortal(state, portalId);
    return portal ? !!portal.isProjectSimplified : false;
};

export const getCategories: (state: State, portalId?: number) => Category[] | undefined | typeof NOT_SUPPORTED = (
    state,
    portalId
) => {
    const portal = getPortal(state, portalId);

    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }

    return undefined;
};
